// The line-art flag, for places that sit beside the other outline icons --
// Page Options' toggle rows, where every neighbour is a thin white stroke on a
// green circle.
//
// FlagIcon is deliberately not reused there: it is a Font Awesome *solid*
// glyph, one filled path with no fill attribute of its own, so it takes the
// default black and reads as a dark blob next to UserGroupIcon and
// LocationIcon. That solid weight is right where it is used (the red/grey flag
// markers on the comps tables) and wrong in a row of outlines, so the two
// coexist rather than one being bent into the other's job.
//
// Same construction as UserGroupIcon: 24 viewBox, no fill, 1.5 stroke, round
// caps and joins. currentColor rather than a hardcoded white so it also works
// anywhere the surrounding text is not white.
export const FlagOutlineIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 21V3.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M5 4h12l-2.5 3.5L17 11H5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
